var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink2 = function SvgLink2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.067 3.996a5.667 5.667 0 0 0-8.184 0l-.71.734a.75.75 0 0 0 1.076 1.044l.71-.734a4.167 4.167 0 0 1 6.03 0c1.681 1.734 1.681 4.554 0 6.288l-1.694 1.748a3.79 3.79 0 0 1-5.483 0l-.273-.282a.75.75 0 1 0-1.078 1.044l.274.282a5.29 5.29 0 0 0 7.637 0l1.695-1.748c2.244-2.315 2.244-6.06 0-8.376M6.705 10.924a3.79 3.79 0 0 1 5.483 0l.273.282a.75.75 0 1 0 1.078-1.044l-.274-.282a5.29 5.29 0 0 0-7.637 0l-1.695 1.748c-2.244 2.315-2.244 6.06 0 8.376a5.667 5.667 0 0 0 8.184 0l.71-.734a.75.75 0 1 0-1.076-1.044l-.71.734a4.167 4.167 0 0 1-6.03 0c-1.681-1.734-1.681-4.554 0-6.288z",
    clipRule: "evenodd"
  })));
};
export default SvgLink2;